import React, { useCallback, useState } from 'react';
import { IconButton } from '@mui/material';
import styles from './styles.module.css';
import { useFrontContext } from '../providers/frontContext';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { track } from '@amplitude/analytics-browser';
import WarningIcon from '@mui/icons-material/Warning';
import { post } from './api';

function GeneratedResponse({
  id,
  generated,
  containsAction,
  latestInbound,
  source,
}) {
  const context = useFrontContext();
  const [thumbDown, setThumbDown] = useState(false);

  const onCreateDraftClick = useCallback(
    (msg) => {
      console.log(latestInbound);
      if (!latestInbound.current) return;
      context.createDraft({
        content: { type: 'text', body: msg },
        replyOptions: {
          type: 'replyAll',
          originalMessageId: latestInbound.current.id,
        },
      });
    },
    [context, latestInbound],
  );

  return (
    <>
      <div style={{ marginBottom: '8px' }}>
        <span>
          <Typography
            sx={{ fontSize: '0.85rem', lineHeight: 1.2, textAlign: 'left' }}
            onClick={() => {
              track('SUGGESTED_RESPONSE_CLICKED', { source });
            }}
          >
            <strong>Suggested draft: </strong>
            {generated}
            {containsAction && (
              <div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <WarningIcon style={{ marginTop: '8px' }} />
                  <div
                    style={{ marginLeft: '8px' }}
                    className={styles.subscriptionItem}
                  >
                    Careful! this suggestion might assume that an agent action
                    has been performed.
                  </div>
                </div>
              </div>
            )}
          </Typography>
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            track('COPY_RESPONSE_BUTTON_CLICKED', { source });
            onCreateDraftClick(generated);
            post('react', {
              generated_message_id: id,
              reaction: 'copy',
            });
          }}
        >
          Copy
        </Button>
        <IconButton
          style={{ marginLeft: '8px' }}
          onClick={() => {
            if (thumbDown) {
              track('THUMBDOWN_BUTTON_UNCLICKED', { source });
              post('react', {
                generated_message_id: id,
                reaction: 'cancel_thumbs_down',
              });
              setThumbDown(false);
            } else {
              track('THUMBDOWN_BUTTON_CLICKED', { source });
              post('react', {
                generated_message_id: id,
                reaction: 'thumbs_down',
              });
              setThumbDown(true);
            }
          }}
        >
          {thumbDown ? <ThumbDownAltIcon /> : <ThumbDownOffAltIcon />}
        </IconButton>
      </div>
    </>
  );
}
export default GeneratedResponse;
